import { Button } from "components";
import React from "react";
import styled from "styled-components";
import { ReactComponent as FilterListRoundedIcon } from 'assets/icons/filter-list.svg';


const FilterWrpper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;

    svg {
        margin-bottom: 5px;
        color: #343741;
    }
`;
const FilterlabelWrpper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
const Filterlabel = styled.p`
    color: #343741;
    font-size: 14px;
    margin-left: 8px;
`;
const FilterCount = styled.p`
    background: #e0e5ee;
    padding: 4px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 5px;
    display: flex;
    align-items: center;
    margin-right: 10px;
`;
function FilterLabel({ handelClearAllFilters, filtersCount }) {
    return (
        <>
            <FilterWrpper>
                <FilterListRoundedIcon />
                <FilterlabelWrpper>
                    <Filterlabel>Filter</Filterlabel>
                    <FilterCount>{filtersCount}</FilterCount>
                </FilterlabelWrpper>
                <Button
                    name="Clear All"
                    type="button"
                    btnStyle="primaryBtn"
                    onChange={handelClearAllFilters}
                />
            </FilterWrpper>
        </>
    );
}

export default FilterLabel;
